import { databases } from '../lib/appwrite';
import { Query } from 'appwrite';

// ============================================
// CONDOMINIUM SERVICE (Database Connected)
// ============================================

const DATABASE_ID = process.env.REACT_APP_APPWRITE_DATABASE_ID;
const CONDOMINIUM_COLLECTION_ID = process.env.REACT_APP_APPWRITE_CONDOMINIUM_COLLECTION_ID;

/**
 * Get all condominiums from the database
 * @returns {Promise<Array>} - Array of condominium objects
 */
export const getAllResidences = async () => {
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      CONDOMINIUM_COLLECTION_ID
    );
    
    return response.documents.map(doc => ({
      id: doc.$id,
      name: doc.name,
      address: doc.address
    }));
  } catch (error) {
    console.error('Error fetching condominiums:', error);
    throw error;
  }
};

/**
 * Get a single residence by ID
 * @param {string} residenceId - The residence ID
 * @returns {Promise<Object>} - Residence object
 */
export const getResidenceById = async (residenceId) => {
  try {
    // TODO: Uncomment when residences collection is created
    // const residence = await databases.getDocument(
    //   DATABASE_ID,
    //   RESIDENCES_COLLECTION_ID,
    //   residenceId
    // );
    // return {
    //   id: residence.$id,
    //   name: residence.name,
    //   location: residence.location,
    //   address: residence.address,
    //   isActive: residence.is_active
    // };
    
    // Mock data
    const residences = await getAllResidences();
    return residences.find(r => r.id === residenceId);
  } catch (error) {
    console.error('Error fetching residence:', error);
    throw error;
  }
};

/**
 * Get active condominiums (all condominiums for now)
 * @returns {Promise<Array>} - Array of condominium objects
 */
export const getActiveResidences = async () => {
  try {
    // Return all condominiums
    // If you add an is_active field later, uncomment the query below
    const response = await databases.listDocuments(
      DATABASE_ID,
      CONDOMINIUM_COLLECTION_ID
      // Uncomment below if you add is_active attribute:
      // [Query.equal('is_active', true)]
    );
    
    return response.documents.map(doc => ({
      id: doc.$id,
      name: doc.name,
      address: doc.address
    }));
  } catch (error) {
    console.error('Error fetching active condominiums:', error);
    throw error;
  }
};

// ============================================
// DATABASE SCHEMA REFERENCE
// ============================================
// 
// Condominiums Collection Schema:
// Collection ID: condominium
// 
// Attributes:
// - name (String): Name of the condominium (e.g., "Monash Waterfront Residence")
// - address (String): Physical location details
// 
// Optional attributes you can add:
// - is_active (Boolean): Whether the condominium is currently active
// - location (String): Area/city location
// - pickup_points (Relationship): Related pickup points
// 
// Permissions:
// - Collection Level:
//   * Any: Read (so all users can see available condominium